export default __webpack_public_path__ + "static/media/rec-staffing.9bff49dd.png";